export const ARCHIVED_STATUS = 'Archived' as const;

export const visibleStatus = (status?: string, isArchived?: boolean) => (
  isArchived ? ARCHIVED_STATUS : status
);

export const isNewlyCompleted = (
  previousStatus: string | undefined,
  nextStatus: string,
) => nextStatus === 'Completed' && previousStatus !== 'Completed';

export type StatusChangePatch<T extends string> =
  | { isArchived: true }
  | {
      cancelReason?: string | null;
      isArchived?: false;
      status: Exclude<T, typeof ARCHIVED_STATUS>;
    };

export const statusChangePatch = <T extends string>(
  nextStatus: T,
  options: {
    cancelReason?: string | null;
    wasArchived?: boolean;
  } = {},
): StatusChangePatch<T> => {
  if (nextStatus === ARCHIVED_STATUS) {
    return { isArchived: true };
  }
  return {
    ...(options.wasArchived ? { isArchived: false as const } : {}),
    status: nextStatus as Exclude<T, typeof ARCHIVED_STATUS>,
    ...(nextStatus === 'Cancelled' ? { cancelReason: options.cancelReason || null } : {}),
  };
};
